import React from 'react'

import { Box, HTMLToReact } from '@vividseats/vivid-ui-kit'

type Props = {
    article: string
}

const Article: React.FC<Props> = ({ article }) => {
    return (
        <Box paddingTop={9} display="block">
            <HTMLToReact html={article} />
        </Box>
    )
}

export default Article
